import React from "react";
import DocumentDetail from "../common/DocumentDetail";
import { BLANK_PLACEHOLDER } from "config/constant";
import { LETTER_OF_APPROVAL_FIELD as FIELD } from "config/documentConstant";
import { DocumentDtoWithAny } from "models/document/DocumentDtoWithAny";
import { Font, Text, View } from "@react-pdf/renderer";
import Html from "react-pdf-html";
import { styles } from "pages/document/work/detail/style";
import { sanitizeContent } from "utils/htmlTranslate";

Font.registerEmojiSource({
  format: "png",
  url: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@15.0.1/img/apple/64/",
  withVariationSelectors: true,
});

interface LetterOfApprovalDetailProps {
  documentData: DocumentDtoWithAny["documentData"];
}

const LetterOfApprovalDetail = ({
  documentData,
}: LetterOfApprovalDetailProps) => {
  return (
    <>
      <DocumentDetail.Section>
        <DocumentDetail.Field label={FIELD.DOCUMENT_NUMBER.label}>
          <Text
            style={{
              fontFamily: "Pretendard",
              fontSize: "10pt",
            }}
          >
            {documentData[FIELD.DOCUMENT_NUMBER.key] || BLANK_PLACEHOLDER}
          </Text>
        </DocumentDetail.Field>

        <DocumentDetail.Field label={FIELD.TITLE.label}>
          <Text
            style={{
              fontFamily: "Pretendard",
              fontSize: "10pt",
            }}
          >
            {documentData[FIELD.TITLE.key] || BLANK_PLACEHOLDER}
          </Text>
        </DocumentDetail.Field>

        <DocumentDetail.Field>
          <View
            style={{
              display: "flex",
              borderBottom: "1px solid #C6C8CD",
              paddingVertical: 24,
            }}
          >
            <Text
              style={{
                fontFamily: "Pretendard",
                fontSize: "10pt",
                color: "#3A4552",
                fontWeight: "semibold",
              }}
            >
              다음과 같이 품의드리오니 승인하여 주시기 바랍니다.
            </Text>
          </View>
        </DocumentDetail.Field>

        <View style={{ marginVertical: 12 }}>
          <Html stylesheet={styles}>
            {sanitizeContent(documentData.content) || BLANK_PLACEHOLDER}
          </Html>
        </View>
      </DocumentDetail.Section>
    </>
  );
};

export default LetterOfApprovalDetail;

/* 스타일 */
// const ContentBusinessGreetingStyle = styled.div`
//   height: 7.2rem;
//   display: flex;
//   align-items: center;

//   ${({ theme }) => theme.typography.body1.semibold}

//   border-bottom: 0.1rem solid ${({ theme }) => theme.color.stroke.dark}
// `;
